const SortingDirections = {
    ACS: 'asc',
    DESC: 'desc',
};

export { SortingDirections };